import React from 'react';
import GeneralModal from '../../../../components/UI/modal/GeneralModal';
import AlertUser from '../../../../components/Alerts/AlertUser';
import useTags from '../../../../hooks/useTags';
import addFileToReqModalLang from '../../../../data/lang/homePage/addFileToReqModal.lang';
import {
    useCloseAddFileModal, useGetAddFileModalForm, useGetAlertStateAddFileModal,
    useGetModalStepAddFileModal,
    useGetOtpCodeAddFileModal, useGetPersonIdNumAddFileModal, useGetVehicleNumAddFileModal,
    useIsAddFileModalOpen, useSetAlertStateAddFileModal, useSetFileError, useSetFileValue,
    useSetStepModalAddFileAsSuccessMsg
} from '../../../../stores/addFileModal.store';
import InputGroup from '../../../../components/form/InputGroup';
import SendFormBtm from '../../../../components/buttons/SendFormBtm';
import { addFileSchema } from '../../../../validations/schema/add-file-validation';
import formErrorsLang from '../../../../data/lang/form-errors.lang';
import useHomePageApi from '../../../../axios/useHomePage.api';
import { convertFileToSendToServer } from '../../../../helpers/convertors';
import ExistBtn from '../../../../components/buttons/ExistBtn';


const AddFileModal = () => {

    const isOtpModalOpen = useIsAddFileModalOpen();

    const modalStep = useGetModalStepAddFileModal();
    const setAlertState = useSetAlertStateAddFileModal();
    const alertState = useGetAlertStateAddFileModal();
    const setFileValue = useSetFileValue();
    const setFileError = useSetFileError();
    const { error, touched, value } = useGetAddFileModalForm();
    const setStepModalAsSuccessMsg = useSetStepModalAddFileAsSuccessMsg();
    const personIdNum = useGetPersonIdNumAddFileModal();
    const vehicleNum = useGetVehicleNumAddFileModal();
    const otpCode = useGetOtpCodeAddFileModal();

    const { addFileToRequestOtpApi } = useHomePageApi();

    const closeModal = useCloseAddFileModal();

    const generateTag = useTags();

    const modalTitleTag = generateTag(addFileToReqModalLang, 'modal-title');
    const fileInputLabelTag = generateTag(addFileToReqModalLang, 'form.file-input-label');
    const sendFileBtnTag = generateTag(addFileToReqModalLang, 'form.send-file-btn');
    const successMsgTag = generateTag(addFileToReqModalLang, 'success-msg');

    return (
        <GeneralModal
            show={isOtpModalOpen}
            closingFunc={closeModal}
            title={modalTitleTag}
            modalSize='S'
            alertUser={<AlertUser state={alertState} />}
            loading={alertState.alertStatus === 'loading'}
            body={(
                <>
                    {modalStep === 'form' && (
                        <div className='container'>
                            <div className='row'>
                                <div className='col-12'>
                                    <InputGroup
                                        label={fileInputLabelTag}
                                        name='value'
                                        type='file'
                                        isRequired
                                        handleChange={handleFileChange}
                                        handleBlur={handleBlur}
                                        errorMsg={touched && error ? error : undefined}
                                    />
                                </div>
                            </div>
                        </div>
                    )}
                    
                    {modalStep === 'successMsg' && (
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }} className='p-4'>
                            <p className='fs-3'>{successMsgTag}</p>
                        </div>
                    )}
                </>

            )}
            footer={(
                <>

                    <SendFormBtm btnLabel={sendFileBtnTag} show={modalStep === 'form'}
                        onClick={handleSendFile}
                        isLoading={alertState.alertStatus === 'loading'}
                    />

                    {modalStep === 'successMsg' && (
                        <ExistBtn onClick={closeModal} />
                    )}
                </>
            )}
        />
    );

    async function handleFileChange(event: React.ChangeEvent<HTMLInputElement>) {

        const value = event.currentTarget.files ? event.currentTarget.files[0] : null;

        const fileData = await convertFileToSendToServer(value, 'extraFile');
        setFileValue(fileData);
    }

    async function handleBlur(event: React.FocusEvent<HTMLInputElement>) {

        const [isValid, errorPathToMsg] = await valided();
        let errorMsg = '';

        if (!isValid) {
            errorMsg = errorPathToMsg;
        }

        setFileError(isValid, generateTag(formErrorsLang, errorMsg));
    }

    async function valided(): Promise<[boolean, string]> {

        console.log(value);
        try {

            await addFileSchema.validateAt('value', { value });
        } catch (err) {

            if (err instanceof Error) {

                setFileError(false, err.message);
                return [false, err.message];
            }
        }

        return [true, ''];
    }

    async function handleSendFile() {

        setAlertState('loading');
        setFileError(true);

        let errorMsg = '';
        const [isValid,] = await valided();

        if (!isValid) {

            setAlertState('noAlert');
            return;
        }

        const dataTosent = {
            personId: personIdNum,
            vehicleNum: vehicleNum,
            otpCode: otpCode,
            file: value,
        }

        const response = await addFileToRequestOtpApi(dataTosent);

        if (!response.isSuccess) {

            errorMsg = response.message;
            setAlertState('hasAlert', errorMsg, 'danger');
            return;
        }

        setStepModalAsSuccessMsg();
        setAlertState('noAlert');
    }
}

export default AddFileModal;